{
  "de": {
    "sales": {
      "actions": {
        "assign_lead": "Lead zuweisen",
        "publish": "Veröffentlichen",
        "remove_lead_from_deal": "Lead vom Deal entfernen",
        "unpublish": "Veröffentlichung aufheben",
        "update_status": "Status aktualisieren",
        "upload_document": "Vertrag hochladen",
        "view_contracts": "Verträge anzeigen"
      },
      "attributes": {
        "status": "Status"
      },
      "labels": {
        "assign_customer": "Kunden zuweisen",
        "assign_customer_mark_sold": "Kunde zuweisen, um als verkauft zu markieren",
        "assign_lead_to_unit": "Lead der Einheit zuweisen",
        "assigned_by": "Zugewiesen von",
        "contracts": "Verträge",
        "expiry_date": "Ablaufdatum der Reservierung",
        "go_to_unit_part_1": "Diese Einheit wurde verkauft. Wenn Sie den Status aktualisieren möchten, müssen Sie zur",
        "go_to_unit_part_2": "gehen und dort zunächst als Sicherheitsmaßnahme die Zuweisung des Kunden aufheben.",
        "interested_leads": "{count} interessierte Leads",
        "internal_note": "Interne Notiz",
        "latest_phase": "Letzte Phase",
        "lead_existing": "Bestehender Lead",
        "lead_new": "Neuer Lead",
        "leads_count": "{count} Leads",
        "mark_as_sold": "Als verkauft markieren",
        "not_published_sales_partners": "Nicht für Vertriebspartner veröffentlicht",
        "not_shown_interest": "Dieser Lead hat an keiner Einheit Interesse gezeigt",
        "note_explainer": "Diese Notiz ist nur für Ihr Team sichtbar",
        "publish_unit": "1 Einheit für alle Vertriebspartner veröffentlichen | {count} Einheiten für alle Vertriebspartner veröffentlichen",
        "published_sales_partners": "Für Vertriebspartner veröffentlicht",
        "reserved_by": "Reserviert von",
        "reserved_warning": "Diese Einheit ist derzeit von {lead_name} reserviert. Wenn Sie diese Einheit als verkauft markieren, wird diese Reservierung storniert.",
        "sales": "Verkauf",
        "selling_price": "Verkaufspreis",
        "selling_price_max": "Maximaler Verkaufspreis",
        "selling_price_min": "Minimaler Verkaufspreis",
        "sold_date": "Verkauft am",
        "sorting": {
          "deal_lead_group_name": "Lead",
          "deal_status": "Status",
          "name": "Einheit"
        },
        "status": "Status",
        "statuses": {
          "available": "Verfügbar",
          "interested": "Interessiert",
          "lost": "Verloren",
          "reserved": "Reserviert",
          "sold": "Verkauft"
        },
        "tab_sales_documents": "Dokumente",
        "tab_sales_tickets": "Konversationen",
        "tab_sales_units": "Einheiten",
        "unit": "Einheit",
        "unit_information_page": "Einheiteninformationsseite",
        "unit_sales_status_header": "Diese Einheit steht zum Verkauf",
        "unpublish_unit": "Veröffentlichung für 1 Einheit für alle Vertriebspartner aufheben | Veröffentlichung für {count} Einheiten für alle Vertriebspartner aufheben",
        "update_sales_status": "Verkaufsstatus der Einheit aktualisieren",
        "upload_sales_doc": "Vertrag hochladen"
      },
      "toasts": {
        "lead_assigned": "Lead zugewiesen"
      },
      "validation": {
        "already_reserved_sold": "Diese Einheit ist bereits für einen anderen Lead reserviert!",
        "already_reserved_sold_info": "Wenn Sie sicher sind, dass Sie den Status für den aktuellen Lead ändern möchten, müssen Sie zunächst den Status des Deals ändern, der derzeit Priorität hat. Sobald Sie den Status für den anderen Deal geändert haben, können Sie zurückkehren und den Status sicher aktualisieren.",
        "need_sold_date": "Datum dieses Verkaufs erforderlich",
        "reserved_expiry_date": "Ablaufdatum für diese Reservierung erforderlich"
      }
    }
  }
}
